<template>
	<div class="announcement-overview">
		<MStateBox :loading="isLoading" :empty="isEmpty">
			<MobDocumentCard
				v-if="currentData.length"
				:listData="currentData"
				:showIcon="true"
				@goDetail="handlePreview"
			/>
		</MStateBox>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import MobDocumentCard from '@rebuild/materials/shared/common/MobDocumentCard.vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCurrentContext } from '../context';
import i18n, { ZH, getLanguageType } from '@/locales';
import { useCommonData } from '@/hooks';

const { announcement } = useModuleData();
const { viewModule } = useModuleNavigation();

const { isFlowXTmpl } = useCommonData();

const context = useCurrentContext();
const languageType = computed(() => context.languageType);

const currentData = computed(() => {
	const data = announcement.data?.data || announcement.data?.rows || [];
	return data.slice(0, 4).map(item => ({
		...item,
		time: item.publishDate,
		classificationInfo: item.parentClassification
	}));
});

const isLoading = computed(() => announcement.loading);
const isEmpty = computed(() => announcement.empty || !currentData.value.length);

const handlePreview = info => {
	viewModule('announcement', info);
};

const refresh = async () => {
	let obj = {
		useStockCode: !isFlowXTmpl.value, // flow模板使用股票代码API
		pageNum: 20,
		pageStart: 0,
		order: 'desc',
		isPublish: true
	};
	if (languageType.value) {
		obj = { ...obj, ...languageType.value };
	}
	if (context.forceFullCode) {
		obj.fullCode = context.forceFullCode;
		if(context.forceFullCode == 'hk01898') {
			obj.sourceLanguageType = i18n.locale === ZH ? 2 : getLanguageType();
			obj.languageType = i18n.locale === ZH ? 2 : getLanguageType();
		}
		if(context.forceFullCode == 'sz003010') {
			obj.sourceLanguageType = 0;
			obj.languageType = 0
		}
	}
	await announcement.refresh(obj);
};

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped></style>
